import { useState } from "react";
import NotificationManager from "../../components/notifications/NotificationManager";
import WatsonApi from "../../backends/WatsonApi";
import { useStores } from "../../stores/useStores";
import { runInAction } from "mobx";

export function SocialSettingsTab() {
  const { organizationStore } = useStores();

  const [hasChanged, setHasChanged] = useState(false);
  const [facebookUrl, setFacebookUrl] = useState(
    organizationStore.organization.json_data.settings.social?.facebook || "",
  );
  const [twitterUrl, setTwitterUrl] = useState(
    organizationStore.organization.json_data.settings.social?.twitter || "",
  );
  const [instagramUrl, setInstagramUrl] = useState(
    organizationStore.organization.json_data.settings.social?.instagram || "",
  );
  const [youtubeUrl, setYoutubeUrl] = useState(
    organizationStore.organization.json_data.settings.social?.youtube || "",
  );
  const [linkedinUrl, setLinkedinUrl] = useState(
    organizationStore.organization.json_data.settings.social?.linkedin || "",
  );

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      const client = await WatsonApi();
      const response = await client.apis.settings.settings_update(
        {
          id: organizationStore.currentOrganization.id,
        },
        {
          requestBody: {
            social: {
              facebook: facebookUrl,
              twitter: twitterUrl,
              instagram: instagramUrl,
              youtube: youtubeUrl,
              linkedin: linkedinUrl,
            },
          },
        },
      );

      const settings = response.body.settings;
      if (settings) {
        runInAction(() => {
          organizationStore.organization.json_data.settings = settings;
        });
        NotificationManager.success("Settings successfully updated!");
      }
    } catch (e) {
      switch (e.statusCode) {
        case 400:
          NotificationManager.error("Bad Request: Settings not updated.");
          break;
        case 404:
          NotificationManager.error(
            "Not Found: Organization settings not found.",
          );
          break;
        case 500:
          NotificationManager.error(
            "Internal Server Error: Settings not updated.",
          );
          break;
        default:
          NotificationManager.error("Unknown Error: Settings not updated.");
      }
    }
  }

  return (
    <div id="social-tab">
      <div className="sb-settings-block-content-heading">
        <h4>Social Networks</h4>
      </div>
      <form
        id="district-social-form"
        onSubmit={handleSubmit}
        onChange={() => setHasChanged(true)}
      >
        <div className="row">
          <div className="col-sm-3">
            <label>Facebook URL:</label>
          </div>
          <div className="col-sm-4">
            <input
              title="Facebook URL"
              type="text"
              value={facebookUrl}
              onChange={(e) => setFacebookUrl(e.target.value)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <label>Twitter URL:</label>
          </div>
          <div className="col-sm-4">
            <input
              title="Twitter URL"
              type="text"
              value={twitterUrl}
              onChange={(e) => setTwitterUrl(e.target.value)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <label>Instagram URL:</label>
          </div>
          <div className="col-sm-4">
            <input
              title="Instagram URL"
              type="text"
              value={instagramUrl}
              onChange={(e) => setInstagramUrl(e.target.value)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <label>Youtube URL:</label>
          </div>
          <div className="col-sm-4">
            <input
              title="Youtube URL"
              type="text"
              value={youtubeUrl}
              onChange={(e) => setYoutubeUrl(e.target.value)}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-3">
            <label>LinkedIn URL:</label>
          </div>
          <div className="col-sm-4">
            <input
              title="LinkedIn URL"
              type="text"
              value={linkedinUrl}
              onChange={(e) => setLinkedinUrl(e.target.value)}
            />
          </div>
        </div>
        <div className="sb-settings-block-footer">
          <button
            type="submit"
            className="btn sb-organization-color-element-bg"
            name="submit"
            disabled={!hasChanged}
          >
            Save
          </button>
        </div>
      </form>
    </div>
  );
}
